// extracted by mini-css-extract-plugin
export default {"zoomModal":"t3-z","image":"u3-z","button":"v3-z","isOverlayShown":"w3-z"};